import { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../redux/features/appData/appDataSlice";
import "./ManageResourcesMenu.css";
import "../../css/Icons.css";

import ModalDeleteResourceFolderConfirm from "./ModalDeleteResourceFolderConfirm";

const RESOURCES_MENU = {
  DELETE_FOLDER: "delete_folder",
};

type ManageResourcesMenuProps = {
  folderName: string;
  fileCount: number;
  onDelete: any;
};

export default function ManageResourcesMenu({
  onDelete,
  folderName,
  fileCount,
}: ManageResourcesMenuProps) {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const storeUser = useSelector(selectUser);

  const [showDeleteConfirm, setShowDeleteConfirm] = useState<boolean>(false);

  const handleButtonClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuSelection = (selection: string) => {
    // close the menu
    setAnchorEl(null);

    // route it
    switch (selection) {
      case RESOURCES_MENU.DELETE_FOLDER:
        setShowDeleteConfirm(true);
        break;
      default:
    }
  };

  return (
    <>
      <div
        className="manage-resources-image-and-name"
        onClick={handleButtonClick}>
        <div className="manage-resources-caret">
          <img src="/icons/three_dots_vertical.png" />
        </div>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}>
        <MenuItem
          onClick={() => handleMenuSelection(RESOURCES_MENU.DELETE_FOLDER)}>
          Delete Folder Resources
        </MenuItem>
      </Menu>

      {showDeleteConfirm && (
        <ModalDeleteResourceFolderConfirm
          isOpen={showDeleteConfirm}
          onClose={() => setShowDeleteConfirm(false)}
          onContinue={() => {
            setShowDeleteConfirm(false);
            onDelete();
          }}
          folderName={folderName}
          fileCount={fileCount}
        />
      )}
    </>
  );
}
